export const scenarioTables = [
  { label: "Bill Rate", key: "avgBillingRate" },
  { label: "Monthly Salary", key: "avgExpectedSalaryOfConsultant" },
];
